import {Pipe, PipeTransform} from '@angular/core';
import {GebaeudeArt} from "../../../core/av-api";
import {TranslateNamePipe} from "./translate-name.pipe";

@Pipe({
  name: 'gebaeudeArtString'
})
export class GebaeudeArtStringPipe implements PipeTransform {


  constructor(private translateName: TranslateNamePipe) {
  }

  transform(gebaeudeArten: Array<GebaeudeArt>): string {
    let gebaeudeArtString = '';
    for (const art of gebaeudeArten) {
      if (art.code) {
        gebaeudeArtString += (gebaeudeArtString.length > 0 ? ' ' : '') + this.translateName.transform(art.code.text);
      }
      if (art.zusatz) {
        gebaeudeArtString += ' ' + art.zusatz;
      }
    }
    return gebaeudeArtString;
  }
}
